import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

const posts = [
  {
    id: 1,
    title: '¿CÓMO HA EVOLUCIONADO EL SECTOR TRANSPORTES EN LA ECONOMÍA DEL PERÚ?',
    summary: 'El transporte es una demanda derivada del intercambio comercial, movilizando mercancías a nivel nacional e internacional. La oferta de servicios de transporte es clave para la economía peruana.',
    content: 'El transporte es una demanda derivada del intercambio comercial, puesto que sirve para movilizar las mercancías que se comercializan ya sea a nivel nacional o internacional. En consecuencia, la oferta de servicios de transporte constituye una condición necesaria para sostener el crecimiento económico. Con innovación, eficiencia y desarrollo de infraestructura, el sector ha evolucionado para responder a las necesidades del país.',
    image: '/blog1.webp',
  },
  {
    id: 2,
    title: '¿CUÁL ES LA RELEVANCIA DEL TRANSPORTE DE CARGA POR CARRETERA EN EL PERÚ?',
    summary: 'El transporte carretero de carga domina el sistema peruano, movilizando más de 54 millones de toneladas anuales y conectando todo el país.',
    content: 'Según información registrada por el Plan Intermodal de Transportes (MTC, 2005) sobre movimiento de carga en el sistema de transporte peruano, éste alcanza las 54,2 TM anuales, siendo el transporte carretero de carga el que domina con una participación del 80%. Esto resalta la importancia de la infraestructura vial y la modernización de la flota para la economía nacional.',
    image: '/blog2.webp',
  },
  {
    id: 3,
    title: 'OBRAS EN LA CARRETERA LIMA-CANTA CULMINARÁN EN PRIMER SEMESTRE',
    summary: 'El MTC anunció la pronta culminación de obras clave para la conectividad entre Lima y Canta, mejorando la infraestructura vial para el transporte de carga.',
    content: 'El titular del MTC, José Gallardo, anunció que en setiembre se inaugurará el tramo que une La Oroya y Cerro de Pasco. La construcción de la carretera que conecta Lima y Canta estará lista en el primer semestre de este año, mejorando la conectividad y facilitando el transporte de carga y pasajeros.',
    image: '/blog3.webp',
  },
];

const Blog: React.FC = () => {
  const [selected, setSelected] = useState<null | typeof posts[0]>(null);

  return (
    <>
      <Helmet>
        <title>Blog | Royal Trucking</title>
        <meta name="description" content="Noticias, tendencias y novedades del sector transporte de carga, logística y camiones en Perú. Royal Trucking comparte información relevante para clientes y empresas." />
      </Helmet>
      <div className="min-h-screen bg-gray-100">
        <section className="relative bg-gradient-to-r from-primary-900 to-primary-700 text-white py-20" data-aos="fade-up">
          <div className="absolute inset-0 bg-primary-600/90 z-0"></div>
          <div className="relative z-10 max-w-4xl mx-auto px-4 py-10 text-center">
            <h1 className="text-4xl lg:text-5xl font-bold mb-2">Blog de Transporte y Logística</h1>
            <p className="text-lg text-primary-100">Noticias, tendencias y novedades del sector transporte de carga en Perú.</p>
          </div>
        </section>
        <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-1 lg:grid-cols-3 gap-10">
          {/* Columna principal de artículos */}
          <div className="lg:col-span-2 flex flex-col gap-8">
            {posts.map(post => (
              <div key={post.id} className="bg-white rounded-xl shadow flex flex-col md:flex-row overflow-hidden border border-gray-200">
                <div className="md:w-1/3 w-full h-56 md:h-auto flex-shrink-0 bg-gray-200 flex items-center justify-center">
                  <img src={post.image} alt={post.title} className="object-cover w-full h-full" onError={e => (e.currentTarget.style.display='none')} />
                </div>
                <div className="flex-1 flex flex-col p-6 justify-between">
                  <div>
                    <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-2 uppercase">{post.title}</h2>
                    <p className="text-gray-700 mb-4 text-sm md:text-base">{post.summary}</p>
                  </div>
                  <button onClick={() => setSelected(post)} className="inline-block bg-red-600 text-white px-6 py-2 rounded font-semibold hover:bg-red-700 transition-colors text-sm md:text-base w-max">LEER MÁS</button>
                </div>
              </div>
            ))}
          </div>
          {/* Barra lateral */}
          <aside className="lg:col-span-1 flex flex-col gap-8">
            {/* Artículos / Categoría */}
            <div className="bg-white rounded-xl shadow border border-gray-200">
              <h3 className="bg-gray-100 px-6 py-3 font-bold text-gray-800 border-b border-gray-200 uppercase text-sm">ARTÍCULOS</h3>
              <div className="px-6 py-3">
                <div className="bg-red-600 text-white px-3 py-2 rounded font-bold text-center text-sm">SIN CATEGORÍA</div>
              </div>
            </div>
            {/* Recientes */}
            <div className="bg-white rounded-xl shadow border border-gray-200">
              <h3 className="bg-gray-100 px-6 py-3 font-bold text-gray-800 border-b border-gray-200 uppercase text-sm">RECIENTES</h3>
              <div className="flex flex-col gap-4 p-4">
                {posts.map(post => (
                  <button key={post.id} onClick={() => setSelected(post)} className="flex gap-3 items-center group w-full text-left">
                    <img src={post.image} alt={post.title} className="w-20 h-14 object-cover rounded border border-gray-200" onError={e => (e.currentTarget.style.display='none')} />
                    <span className="font-bold text-xs text-red-600 group-hover:underline uppercase leading-tight">{post.title}</span>
                  </button>
                ))}
              </div>
            </div>
          </aside>
        </div>
        {/* Modal de detalle */}
        {selected && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
            <div className="bg-white rounded-xl shadow-xl max-w-lg w-full p-8 relative animate-fade-in">
              <button onClick={() => setSelected(null)} className="absolute top-3 right-3 text-gray-500 hover:text-red-600 text-2xl font-bold">&times;</button>
              <img src={selected.image} alt={selected.title} className="w-full h-48 object-cover rounded mb-4" />
              <h2 className="text-xl font-bold text-gray-900 mb-2 uppercase">{selected.title}</h2>
              <p className="text-gray-700 mb-4 text-sm md:text-base">{selected.content}</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Blog; 